import React from 'react';
import styled, { keyframes } from 'styled-components';
import i18n from '@/i18n/config';

// 渐入动画
const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

// 脉冲动画
const pulse = keyframes`
  0%, 100% {
    opacity: 0.4;
  }
  50% {
    opacity: 1;
  }
`;

// 加载容器
const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: calc(var(--vh, 1vh) * 100);
  width: 100vw;
  position: fixed;
  top: 0;
  left: 0;
  background: #0a0a0a;
  animation: ${fadeIn} 0.3s ease-in-out;
  z-index: 9999;
  overflow: hidden;
`;

// 加载指示器
const LoadingIndicator = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 24px;
`;

// 加载点 - 使用 $ 前缀避免属性传递到 DOM
const LoadingDot = styled.div<{ $delay: number }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: linear-gradient(123deg, #feae45 19.66%, #ff6d49 67.36%);
  animation: ${pulse} 1.4s ease-in-out infinite;
  animation-delay: ${props => props.$delay}s;
`;

// 加载文本
const LoadingText = styled.div`
  color: rgba(255, 255, 255, 0.75);
  font-size: 14px;
  font-weight: 400;
  text-align: center;
  animation: ${pulse} 2s ease-in-out infinite;
`;

// 进度条容器
const ProgressContainer = styled.div`
  width: 200px;
  height: 2px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 1px;
  margin-top: 16px;
  overflow: hidden;
`;

// 进度条
const ProgressBar = styled.div`
  height: 100%;
  background: linear-gradient(123deg, #feae45 19.66%, #ff6d49 67.36%);
  border-radius: 1px;
  animation: ${keyframes`
    0% {
      width: 0%;
      transform: translateX(-100%);
    }
    50% {
      width: 100%;
      transform: translateX(0%);
    }
    100% {
      width: 100%;
      transform: translateX(100%);
    }
  `} 2s ease-in-out infinite;
`;

/**
 * 路由加载中的占位组件
 * 显示一个优雅的加载指示器，提供更好的用户体验
 */
const RouteLoadingFallback: React.FC = () => {
  return (
    <LoadingContainer>
      <LoadingIndicator>
        <LoadingDot $delay={0} />
        <LoadingDot $delay={0.2} />
        <LoadingDot $delay={0.4} />
      </LoadingIndicator>
      <LoadingText>{i18n.t('common.pageLoading')}</LoadingText>
      <ProgressContainer>
        <ProgressBar />
      </ProgressContainer>
    </LoadingContainer>
  );
};

export default RouteLoadingFallback;
